import { IconButton, Tooltip } from '@mui/material';
import './i-readonlyfield.component.scss'
import { isNotEmpty } from '../../../features/common/util.services';

const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
export type IReadonlyProps = {
    label: string,
    value: any,
    onIconClick?: any,
    icon?: React.ComponentType<any> | any,
    iconTitle?: any
}

const IReadOnlyField = (props: IReadonlyProps) => {
    const IconComponent = props.icon;
    return (
        <div className="i-readonlyfield">
            <div className="rof-label-wrapper">
                <span className="rof-label">{props.label}</span>
                <span className="rof-value">{props.value}</span>
                {isNotEmpty(props.icon) && <Tooltip title={props.iconTitle} PopperProps={popperProps}>
                                            <IconButton onClick={props.onIconClick} size="small" className="rof-icon-button">
                                                <IconComponent className="rof-icon" />
                                            </IconButton></Tooltip>}
            </div>
        </div>
    )
};

export default IReadOnlyField;